"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = require("@/utils/index");
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'TargetBoard',
  props: {
    theme: {
      type: String,
      default: ''
    },
    itemData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  computed: (0, _objectSpread2.default)({
    color: function color() {
      if (this.theme === 'blue') {
        return '#95CCFF';
      } else if (this.theme === 'yellow') {
        return '#FEDB00';
      } else if (this.theme === 'orange') {
        return '#FFBF60';
      } else {
        return '';
      }
    }
  }, (0, _vuex.mapGetters)(['homeType'])),
  methods: {
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    }
  }
};